import { Capacitor } from "@capacitor/core";
import { Style } from "@capacitor/status-bar";
import {
  menuBgEl,
  menuDividerEls,
  pickLevelBgEl,
  getCatEls,
  getBodyEls,
  getHeadEls,
  livesHeartEl,
  feedbackDialogEl,
  feedbackDialogOkEl,
  feedbackDialogCancelEl,
  feedbackThanksOkEl,
  feedbackThanksCancelEl,
  feedbackThanksEl,
} from "./elements";
import { NavigationBar, StatusBar } from "./plugins";
import store from "./store";
import { IS_IOS, IS_WEB } from "./config";
import { addClickToBtns } from "./sound";
// import { handleSubscribed } from "./iap/subscription";
// import { hexToRgb } from "./color";

export const THEME_CONFIG = [
  "#728501", // blocked
  "#D3FF01", // free
  "#cfc8c4", // bg
  "black", // text
  // "rgba(0,0,0,0.85)", // text
  "black",
  // "rgb(20,20,20)",
  Style.Light,
  "#728501",
  "#EDF2BE", // non-blockable
  "#e64b2c", // center
  "black", // indicators-text
  // "rgba(0,0,0,0.7)", // indicators-text
  "#bbb2ac", // bg 2
];

export function setSystemBarsThemeInterval(
  color = store.themes[2],
  force = false
) {
  if (!store.introShown && !force) return;
  IS_IOS || NavigationBar.hide();
  const cb = () => {
    setNavigationBarColor(color, store.themes[5]);
    setStatusBarColor(color, store.themes[5]);
  };
  cb();
  for (let i = 1; i < 9; i++) {
    setTimeout(cb, 100 * i);
  }
}

export function setNavigationBarColor(color, style) {
  IS_IOS ||
    NavigationBar.setColor({ color, darkButtons: style == Style.Light });
}

export function setStatusBarColor(color, style) {
  if (Capacitor.getPlatform() == "web") return;
  StatusBar.setStyle({ style });
  StatusBar.setBackgroundColor({ color });
}

export function setColors() {
  //   handleSubscribed();
  //   menuOpenBtnEl.style.color = store.themes[4];
  //   levelLandscapeEl.style.color = store.themes[4];
  menuBgEl.style.backgroundColor = store.themes[2];
  pickLevelBgEl.style.backgroundColor = store.themes[2];
  livesHeartEl.style.color = store.themes[3];
  //   livesCounterEl.style.color = store.themes[3];
  // menu.style.backgroundColor = store.themes[2];
  Array.prototype.forEach.call(
    getCatEls(),
    (element) => (element.style.fill = store.themes[4])
  );
  Array.prototype.forEach.call(
    getBodyEls(),
    (element) => (element.style.stroke = store.themes[4])
  );
  Array.prototype.forEach.call(getHeadEls(), (element) => {
    element.style.stroke = store.themes[4];
    element.style.fill = store.themes[4];
  });
  Array.prototype.forEach.call(menuDividerEls, (element) => {
    element.style.color = store.themes[3];
    element.style.backgroundColor = store.themes[3];
  });
  Array.prototype.forEach.call(
    document.getElementsByClassName("indicator-txt"),
    (element) => (element.style.color = store.themes[9])
  );
  if (!__DEV__)
    Array.prototype.forEach.call(
      document.getElementsByClassName("rm-prod"),
      (element) => (element.style.display = "none")
    );
  if (IS_WEB && !__DEV__)
    Array.prototype.forEach.call(
      document.getElementsByClassName("rm-web"),
      (element) => (element.style.display = "none")
    );
  if (!IS_WEB && !__DEV__)
    Array.prototype.forEach.call(
      document.getElementsByClassName("rm-mobile"),
      (element) => (element.style.display = "none")
    );
  Array.prototype.forEach.call(
    document.getElementsByClassName("rm"),
    (element) => (element.style.display = "none")
  );

  feedbackDialogEl.style.backgroundColor = store.themes[2];
  feedbackDialogCancelEl.style.backgroundColor = "#F8616A";
  feedbackDialogOkEl.style.backgroundColor = "#E0E0E0";

  feedbackThanksEl.style.backgroundColor = store.themes[2];
  feedbackThanksOkEl.style.backgroundColor = "#D3FF01";
  feedbackThanksCancelEl.style.backgroundColor = "#6A7D01";
  feedbackThanksCancelEl.style.color = "white";

  //   levelLandscapeEl.style.backgroundColor = `rgba(${rgb.r},${rgb.g},${rgb.b},0.5)`;
  setStatusBarColor(store.themes[2], store.themes[5]);
  setNavigationBarColor(store.themes[2], store.themes[5]);

  addClickToBtns();
}
